<template>
  <div class="search-form">
    <el-form
      ref="form"
      size="mini"
      :model="form"
      label-position="left"
      onsubmit="return false"
    >
      <el-row :gutter="10">
        <el-col :span="7">
          <el-form-item
            :label="$l('form_label_search_addressType') || '类型'"
            label-width="50px"
          >
            <dict-select
              v-model="form.listAddressType"
              :body="addressTypeParams"
              url="/sys/common/dict/system"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              multiple
              clearable
              filterable
              style="width:100%"
              size="mini"
            >
            </dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item
            :label="$l('form_label_search_address') || '地址'"
            label-width="60px"
          >
            <el-input
              v-model="form.address"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              clearable
              @keyup.enter.native="query"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_linkPoRule') || 'PO规则'"
            label-width="65px"
          >
            <el-input
              v-model="form.linkPoRule"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              clearable
              @keyup.enter.native="query"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <b-button
            class="mr-2"
            size="sm"
            variant="outline-primary"
            @click="query"
          >
            <i class="el-icon-search" />
            {{ $l('INDEX.btn_search') || '搜索' }}
          </b-button>
          <b-button
            class="mr-2"
            size="sm"
            variant="outline-success"
            :disabled="disabled"
            @click="$emit('openEditDialog', { type: 'add' })"
          >
            <i class="el-icon-plus" />
            {{ $l('INDEX.btn_add') || '添加' }}
          </b-button>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
const initForm = { listAddressType: [], address: '', linkPoRule: '' }
export default {
  props: {
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      form: { ...initForm },
      addressTypeParams: { dictType: 'customerAddressType' },
    }
  },
  mounted() {
    this.query()
  },
  methods: {
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', this.form)
    },
    reset() {
      this.form = { ...initForm }
    },
  },
}
</script>
